import { ref, readonly } from 'vue';
import { get, ENDPOINTS, guideErrorMessage, guideHttpStatus } from '@/api/mainApi';
import { PaymentMethod } from '@/interfaces/economy/paymentMethod';
import store from '@/store';

export function usePaymentMethods() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const fetchPaymentMethods = async (): Promise<PaymentMethod[]> => {
    loading.value = true;
    error.value = null;

    try {
      const data = await get(ENDPOINTS.PAYMENT_METHODS);
      return data || [];
    } catch (err) {
      error.value = 'Failed to fetch payment methods';
      window.log?.error('[Guide] paymentMethods.fetch — Failed to fetch payment methods', {
        message: guideErrorMessage(err),
        httpStatus: guideHttpStatus(err),
      });
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    fetchPaymentMethods,
  };
}
